export type PromoCode = {
    id: number;
    userId: number;
    promoCode: string;
    discounts: Array<{
        type: string;
        value: number;
        currency: string;
    }>;
    maxUses: number;
    activeFrom: string;
    activeTo: string;
    timeZone: string;
    status: number;
    used: number;
};

export enum PromoCodeDiscountType {
    percentage = 'percentage',
    money = 'money',
}
